// The ODA statement (toestemming datadeling) as Eleena reports it, as label + Bulma tag class.
// Shared by the task details and the call centre.
import { formatDate } from '@/util/DateTime'

export interface OdaStatusData {
  status: 'active' | 'expired' | 'pending' | 'none'
  start_date: string | null
}

export const ODA_UNKNOWN = { label: 'Onbekend', tagClass: 'is-light' }

const ODA_LABELS: { [status: string]: { label: string; tagClass: string } } = {
  active: { label: 'Getekend', tagClass: 'is-success' },
  pending: { label: 'Ingediend, in behandeling', tagClass: 'is-orange' },
  expired: { label: 'Verlopen, opnieuw tekenen', tagClass: 'is-danger' },
  none: { label: 'Niet getekend', tagClass: 'is-danger' },
}

// data is null when Eleena could not be asked: unknown, not "not signed"
export function odaStatusTag(data: OdaStatusData | null | undefined) {
  const entry = data && ODA_LABELS[data.status]
  if (!entry) return ODA_UNKNOWN
  if (data.status === 'active' && data.start_date) {
    return { ...entry, label: `${entry.label} (sinds ${formatDate(data.start_date)})` }
  }
  return entry
}
